import React, { Component } from 'react';
import $ from 'jquery';
import { Panel } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class Report extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			results: [],
			gradeType: {},
			unitType: {},
		}
	}

	enumGradeFormatter(cell, row, enumObject) {
		return enumObject[cell];
	}
	
	enumUnitFormatter(cell, row, enumObject) {
		return enumObject[cell];
	}

	componentDidMount() {
		var that = this;
		if (this.props.isLogin) {
			$(function(){$.ajax({
				url: URL + 'api/report/',
				headers: {
					'Authorization': 'JWT ' + that.props.token,
				},
				type: "GET",
				dataType: "json",
				success: function(data) {
				        var gradeType = {};
					var unitType = {};
				        data.forEach((word)=>{
						gradeType[word.grade] = word.grade;
						unitType[word.unit] = word.unit;
					});	
					that.setState({results:data,gradeType:gradeType,unitType:unitType,});
				},
				error: function(xhr, status, err) {
					console.log(err.Message);
					that.setState({results:[]});
				}
			})});
		}
	}

	render() {
		return( 
			<Panel>
			  <Panel.Heading>
			    我做错的单词
			  </Panel.Heading>
			  <Panel.Body>
			    <BootstrapTable 
			      data={this.state.results} 
			      striped
			      hover
			      pagination
			      options={{ noDataText: this.props.isLogin?('没有可以显示的数据'):('只有登录才可查询，请登录。') }}
			    >
			      <TableHeaderColumn isKey hidden dataField='id'>
			        ID
			      </TableHeaderColumn>
			      <TableHeaderColumn 
			      	dataField='grade'
				filterFormatted 
				dataFormat={ this.enumGradeFormatter }
				formatExtraData= { this.state.gradeType }
				filter = {{ type: 'SelectFilter',
					options: this.state.gradeType,
					selectText: '选择' }}
				>
			        年级
			      </TableHeaderColumn>
			      <TableHeaderColumn 
			        dataField='unit'
				filterFormatted
				dataFormat={ this.enumUnitFormatter }
				formatExtraData={ this.state.unitType }
				filter = {{ type: 'SelectFilter',
					options: this.state.unitType,
					selectText: '选择' }}
				>
			        单元
			      </TableHeaderColumn>
			      <TableHeaderColumn dataField='english' width={"100"}>
			        单词
			      </TableHeaderColumn>
			      <TableHeaderColumn dataField='chinese'>
			        中文
			      </TableHeaderColumn>
			      <TableHeaderColumn dataField='count' filter={{
				      type: 'NumberFilter',
				      delay: 1000,
				      numberComparators: ['=','>','<=']}}>
			        出错次数
			      </TableHeaderColumn>
			    </BootstrapTable> 
			   </Panel.Body>
			  </Panel>
			  )
	}

}

export default Report;



// WEBPACK FOOTER //
// ./src/Report.js